module.exports = __webpack_public_path__ + "static/media/john-smith.274096ef.png";